import React, { useState, useEffect } from "react";
import "./product.css";
const DiskDropdown = (props) => {
  const [borderAdd, setBorderAdd] = useState(false);
  const [dropDowncollapOn, setdropDownCollapOn] = useState(false);
  const [more, setMore] = useState(false);
  const [moreText, setMoreText] = useState(true);
  const [dropdownOpen, setdropdownOpen] = useState(true);
  const btnCliDrop = () => {
    setdropDownCollapOn(!dropDowncollapOn);
    setdropdownOpen(!dropdownOpen);
  };
  const seeMoredetails = () => {
    setMore(!more);
    setMoreText(!moreText);
  };

  return (
    <div className="card border-none">
      <div
        id="product-description"
        className={
          borderAdd ? "collapse-heading borderAdd" : "collapse-heading"
        }
      >
        <button
          onClick={btnCliDrop}
          className="btn pl-1 collapsed py-md-2 collapserBtn"
          type="button"
        >
          Description
          <span
            className={dropDowncollapOn ? "rotateAngle0" : "rotateAngle180"}
          >
            <i className="fa fa-angle-down" />
          </span>
        </button>
      </div>

      <div
        id="description-collapse"
        className={dropdownOpen ? "collapse show" : "collapse"}
        aria-labelledby="product1description"
        data-parent="#accordion"
      >
        <div className="card-body pl-0">
          <div className="description-body">
            <div className={more ? "moreText" : "lesText"}>
              <p>
                <span>
                  <i style={{ color: "red" }}> Remove Me latter.</i> Lorem ipsum
                  dolor sit amet consectetur adipisicing elit. Nostrum eaque
                  itaque excepturi modi placeat, facilis vero est voluptatibus,
                  aliquam nihil, dolore soluta? Iste, facilis facere quasi ipsa
                  tenetur, accusamus sit deleniti consectetur vel alias nulla
                  recusandae quo quia fugiat laborum et. Modi corporis similique
                  aliquam fugit nisi ipsum eaque ad totam quibusdam eius minus
                  nostrum voluptatibus dicta, explicabo ipsam ullam vel eveniet
                  minima incidunt qui. Expedita repellat aliquid magni ipsum,
                  laborum impedit maiores similique illo deleniti sit inventore
                  rem nemo vero? Optio amet perspiciatis placeat alias. Eaque
                  ipsam rerum perferendis?
                </span>
              </p>
            </div>
            <div onClick={seeMoredetails} className="dropSeeMore">
              {moreText ? (
                <span className="seemoreLink">See More</span>
              ) : (
                <span className="seeLessLink">See Less</span>
              )}
            </div>
            ,{props.children}
          </div>
        </div>
      </div>
      <hr className="my-0" />
    </div>
  );
};

const Dropdown = (props) => {
  const [borderAdd, setBorderAdd] = useState(false);
  const [dropDowncollapOn, setdropDownCollapOn] = useState(false);
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const btnCliDrop = () => {
    setdropDownCollapOn(!dropDowncollapOn);
    setdropdownOpen(!dropdownOpen);
  };

  return (
    <div className="card border-none">
      <div
        id="product-description"
        className={
          borderAdd ? "collapse-heading borderAdd" : "collapse-heading"
        }
      >
        <button
          onClick={btnCliDrop}
          className="btn pl-1 collapsed py-md-2 collapserBtn"
          type="button"
        >
          <div>
            {props.dropdownLable}
            <div className="text-left overflow-hidden dropdownSubtitle">
              <small className="test-subtitle">{props.dropdownSubtitle}</small>
            </div>
          </div>
          <span
            className={dropDowncollapOn ? "rotateAngle180" : "rotateAngle0"}
          >
            <i className="fa fa-angle-down" />
          </span>
        </button>
      </div>

      <div
        id="description-collapse"
        className={dropdownOpen ? "collapse show" : "collapse"}
        aria-labelledby="product1description"
        data-parent="#accordion"
      >
        <div className="card-body pl-0">
          <div className="description-body">{props.children}</div>
        </div>
      </div>
      <hr className="my-0" />
    </div>
  );
};

export { Dropdown, DiskDropdown };
